import React, { useEffect, useState } from 'react'
import moment from 'moment'
import _forEach from 'lodash/forEach'
import _get from 'lodash/get'
import { Field as FormikField, Form, Formik } from 'formik'
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger'
import Tooltip from 'react-bootstrap/lib/Tooltip'
import ClipboardButton from 'react-clipboard.js'
import { Element, Events, scroller } from 'react-scroll'
import Field from '../../_library/Field'
import Button from '../../_library/Button'
import {
  RichTextAreaField,
  SimpleField,
  SelectField,
  DateTimePickerFieldReact,
  FileUploaderField,
  CustomToggleField,
} from '../../formik/Fields'
import { requiredValidator } from '../../../_common/core/validation'
import CustomFieldOptions from '../../_library/CustomFields/CustomFieldOptions'
import { validateForm } from './validation'
import { ENV } from '../../constants/env'
import { FIELDS, FieldWrapper, createOrderOptions, fieldTypeOptions, getScrollToValue } from './utils'

const CustomerFormForm = props => {
  const { selectedFormData, handleSubmitForm, closeModal, emailTemplatesOption, eventId, containerId } = props
  const isEditing = !!selectedFormData
  const baseURL = `${ENV.API_CONSUMER}/form/`

  const [urlCopied, setUrlCopied] = useState(false)

  useEffect(() => {
    if (urlCopied) {
      setTimeout(() => {
        setUrlCopied(false)
      }, 800)
    }
  }, [urlCopied])

  const handleOrderChange = (index, newOrder, values, setFieldValue) => {
    const newFields = [...values.fields]
    const oldOrder = newFields[index].order

    const swapIndex = newFields.findIndex(field => Number(field.order) === Number(newOrder))
    if (swapIndex !== -1) {
      newFields[swapIndex].order = oldOrder
    }

    newFields[index].order = newOrder
    setFieldValue('fields', newFields)
  }

  const initialValues = {
    slug: '',
    title: '',
    subtitle: '',
    description: '',
    startDate: '',
    endDate: '',
    socialImage: '',
    fields: [
      {
        label: 'Email',
        type: 'email',
        name: 'email',
        defaultValue: '',
        order: 1,
        settings: {},
        disabled: true,
        required: true,
      },
    ],
    approvedEmailTemplateId: '',
    declinedEmailTemplateId: '',
    confirmationMessage: '',
  }

  if (Object.keys(selectedFormData || {}).length > 0) {
    _forEach(selectedFormData, (value, key) => (initialValues[key] = value || ''))
    initialValues.startDate = moment(selectedFormData.startDate).isValid()
      ? moment(selectedFormData.startDate).format('YYYY-MM-DD HH:mm:ss')
      : null
    initialValues.endDate = moment(selectedFormData.endDate).isValid()
      ? moment(selectedFormData.endDate).format('YYYY-MM-DD HH:mm:ss')
      : null
    initialValues.fields = _get(selectedFormData, 'fields', [])
  }

  const handleScrollOnError = errors => {
    Events.scrollEvent.register('end', () => {
      Events.scrollEvent.remove('end')
    })
    const scrollTo = getScrollToValue(errors)

    scroller.scrollTo(scrollTo, {
      duration: 800,
      delay: 0,
      smooth: 'easeInOutQuart',
      offset: -120,
      containerId: containerId || null,
    })
  }

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={async (values, { setSubmitting, setErrors }) => {
        handleSubmitForm(values, { setSubmitting, setErrors })
      }}
      validateOnMount={false}
      validate={valuesData => validateForm(valuesData)}
      enableReinitialize
    >
      {({ values, errors, handleSubmit, setFieldValue, isSubmitting, touched }) => {
        if (isSubmitting) {
          handleScrollOnError(errors)
        }
        return (
          <Form className="customer-form-form">
            <Element name="scroll-to-top" />
            <FieldWrapper className="col-xs-12" rowClassName="flex-row">
              <FormikField
                name="slug"
                validate={requiredValidator()}
                render={fieldProps => (
                  <SimpleField
                    {...fieldProps}
                    label={
                      <>
                        Unique URL/Slug
                        <ClipboardButton
                          component="span"
                          data-clipboard-text={baseURL + values.slug}
                          onSuccess={() => setUrlCopied(true)}
                          onClick={e => {
                            e?.preventDefault()
                          }}
                        >
                          <OverlayTrigger
                            placement="right"
                            overlay={
                              <Tooltip id="urlCopied">{urlCopied ? 'Copied' : 'Copy Form URL'}</Tooltip>
                            }
                            trigger={['hover']}
                          >
                            <i className="fa fa-clipboard event-url-copy" />
                          </OverlayTrigger>
                        </ClipboardButton>
                      </>
                    }
                  >
                    <Field.PrefixAddon className="link-prefix hidden-xs">
                      <img
                        alt="no-data"
                        className="link-prefix-img"
                        src={asset('/resources/images/event-url.png')}
                      />
                      <div className="link-prefix-url">{baseURL}</div>
                    </Field.PrefixAddon>
                  </SimpleField>
                )}
              />
            </FieldWrapper>
            <FieldWrapper>
              <FormikField
                name="title"
                label="Title"
                component={SimpleField}
                validate={requiredValidator()}
              />
              <FormikField name="subtitle" label="Subtitle" component={SimpleField} />
            </FieldWrapper>
            <FieldWrapper className="col-xs-12">
              <FormikField component={RichTextAreaField} name="description" label="Description" rows={4} />
            </FieldWrapper>
            <FieldWrapper className="col-xs-12">
              <FormikField
                component={RichTextAreaField}
                name="confirmationMessage"
                label="Confirmation Message"
                rows={4}
              />
            </FieldWrapper>
            <FieldWrapper>
              <FormikField component={DateTimePickerFieldReact} name="startDate" label="Start Date" />
              <FormikField component={DateTimePickerFieldReact} name="endDate" label="End Date" />
            </FieldWrapper>
            <span style={{ padding: '0 10px' }}>
              <p>Images</p>
              <FieldWrapper>
                <FormikField
                  name="backgroundImage"
                  label="Background Image"
                  filetype="image"
                  component={FileUploaderField}
                  accept="image/*"
                />
                <FormikField
                  name="socialImage"
                  label="Social Image"
                  filetype="image"
                  component={FileUploaderField}
                  accept="image/*"
                />
              </FieldWrapper>
            </span>
            <FieldWrapper>
              <FormikField
                name="approvedEmailTemplateId"
                label="Approved Email Template"
                component={SelectField}
                options={emailTemplatesOption}
                // validate={requiredValidator()}
              />
              <FormikField
                name="declinedEmailTemplateId"
                label="Declined Email Template"
                component={SelectField}
                options={emailTemplatesOption}
                // validate={requiredValidator()}
              />
            </FieldWrapper>
            <div style={{ padding: '0 10px', display: 'flex', gap: 10 }}>
              <Button className="btn btn-success" type="button" onClick={() => {}}>
                <a
                  style={{ color: '#0645AD' }}
                  href={`/event/${eventId}/email-templates`}
                  target="_blank"
                  rel="noreferrer"
                >
                  Create Email Template
                </a>
              </Button>
            </div>

            <h3 style={{ padding: '0 10px' }}>Add Custom Fields</h3>
            {values.fields.map((field, index) => (
              <div
                key={index}
                style={{
                  position: 'relative',
                  borderBottom: '1px solid white',
                  padding: '20px 0 5px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 5,
                  pointerEvents: field.disabled ? 'none' : 'auto',
                  opacity: field.disabled ? 0.7 : 1,
                }}
              >
                {!field.disabled && (
                  <span
                    aria-hidden
                    style={{
                      display: 'flex',
                      position: 'absolute',
                      top: 0,
                      right: 0,
                      padding: 5,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      const newFields = [...values.fields].filter((_, itemIndex) => itemIndex !== index)
                      setFieldValue('fields', newFields)
                    }}
                  >
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="removeField">Remove Field</Tooltip>}
                      trigger={['hover']}
                    >
                      <i className={'fa fa-trash fa-lg'} />
                    </OverlayTrigger>
                  </span>
                )}
                <Element name={`scroll-to-field-${index}`} />
                <FieldWrapper>
                  <FormikField
                    name={`fields.${index}.type`}
                    label="Type"
                    component={SelectField}
                    options={fieldTypeOptions}
                    validate={requiredValidator()}
                  />
                  <FormikField
                    name={`fields.${index}.label`}
                    label="Label"
                    component={SimpleField}
                    validate={requiredValidator()}
                  />
                </FieldWrapper>
                {_get(values, `fields.${index}.type`) === FIELDS.SELECT.key && (
                  <CustomFieldOptions
                    values={values}
                    errors={errors}
                    fieldName={`fields.${index}.options`}
                    addBtnLabel="Add Select Option"
                    setFieldValue={setFieldValue}
                  />
                )}
                {_get(values, `fields.${index}.type`) === FIELDS.SELECT_MULTI.key && (
                  <CustomFieldOptions
                    values={values}
                    errors={errors}
                    fieldName={`fields.${index}.options`}
                    addBtnLabel="Add Multi Select Option"
                  />
                )}
                {_get(values, `fields.${index}.type`) === FIELDS.RADIO.key && (
                  <CustomFieldOptions
                    values={values}
                    errors={errors}
                    fieldName={`fields.${index}.options`}
                    addBtnLabel="Add Radio Option"
                  />
                )}
                <FieldWrapper>
                  <FormikField
                    name={`fields.${index}.name`}
                    label="Name"
                    component={SimpleField}
                    validate={requiredValidator()}
                    disabled={!!_get(selectedFormData, `fields.${index}.name`)}
                    // eslint-disable-next-line max-len
                    helperText={`The Name field should not contain numbers or spaces. You can replace spaces with underscore like 'first_name' or 'last_name'.`}
                  />
                  <FormikField
                    name={`fields.${index}.defaultValue`}
                    label="Default Value"
                    component={SimpleField}
                  />
                </FieldWrapper>
                <FieldWrapper rowClassName="v-center">
                  <FormikField
                    name={`fields.${index}.order`}
                    label="Field Order"
                    component={SelectField}
                    options={createOrderOptions(values.fields.length)}
                    onChange={(_, fieldValue) => {
                      handleOrderChange(index, fieldValue, values, setFieldValue)
                    }}
                  />
                  <FormikField
                    name={`fields.${index}.required`}
                    onText="Required"
                    component={CustomToggleField}
                  />
                </FieldWrapper>
              </div>
            ))}
            <div style={{ padding: '0 10px' }}>
              <Button
                className="btn btn-success"
                type="button"
                onClick={() => {
                  const newFields = [...values.fields]
                  newFields.push({
                    label: '',
                    type: 'text',
                    name: '',
                    defaultValue: '',
                    order: values.fields.length + 1,
                    settings: {},
                  })
                  setFieldValue('fields', newFields)
                }}
              >
                Add Field
              </Button>
            </div>
            <div className="modal-footer" style={{ margin: '20px -15px 0px' }}>
              <div className="btn-toolbar btn-toolbar-right">
                <Button
                  className="btn btn-default btn-success"
                  type="button"
                  onClick={() => {
                    handleSubmit()
                  }}
                >
                  {isEditing ? 'Update' : 'Create'}
                </Button>
                <Button className="btn btn-default btn-cancel" type="button" onClick={closeModal}>
                  Cancel
                </Button>
              </div>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}

export default CustomerFormForm
